if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (window.matchMedia('(max-width: 749px)').matches && this.showMobileZoom()) return;
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      // MS 29-oct: en el celular, fotos a pantalla completa con pellizco, doble toque y deslizar (zoom de Swiper, ya en el tema)
      showMobileZoom() {
        const imgs = [...this.querySelectorAll('.product-media-modal__content > img[data-media-id]')];
        const start = imgs.findIndex((img) => img.dataset.mediaId === this.openedBy.getAttribute('data-media-id'));
        this.classList.toggle('ms-zoom-on', start >= 0);
        if (start < 0) return false; // video o 3D: como antes

        if (this.zoomSwiper) {
          this.zoomSwiper.zoom.out();
          this.zoomSwiper.slideTo(start, 0);
          return true;
        }

        const el = document.createElement('div');
        el.className = 'swiper ms-zoom';
        el.innerHTML = '<div class="swiper-wrapper"></div><div class="swiper-pagination"></div>';
        imgs.forEach((img) => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.innerHTML = '<div class="swiper-zoom-container"></div>';
          const clone = img.cloneNode();
          clone.sizes = '200vw';
          slide.firstChild.appendChild(clone);
          el.firstChild.appendChild(slide);
        });
        this.querySelector('[role="dialog"]').appendChild(el);

        const base = document.querySelector('script[src*="product-modal.js"]').src.split('product-modal.js')[0];
        const load = window.Swiper
          ? Promise.resolve()
          : new Promise((resolve) => {
              const css = document.createElement('link');
              css.rel = 'stylesheet';
              css.href = base + 'swiper-bundle.min.css';
              document.head.appendChild(css);
              const js = document.createElement('script');
              js.src = base + 'swiper-bundle.min.js';
              js.onload = resolve;
              document.head.appendChild(js);
            });
        load.then(() => {
          this.zoomSwiper = new Swiper(el, {
            initialSlide: start,
            zoom: { maxRatio: 3 },
            pagination: { el: el.querySelector('.swiper-pagination'), type: 'fraction' },
          });
        });
        return true;
      }
    }
  );
}
